import { Select } from "antd";
import { SelectProps } from "antd/lib";
import React from "react";

export const EventNameSelect = (props: SelectProps) => {
  return (
    <Select
      {...props}
      options={[
        {
          label: "View",
          options: [
            { label: "Impression", value: "EVENT_NAME_ON_IMPRESSION" },
            { label: "Click", value: "EVENT_NAME_ON_CLICK" },
            { label: "Scheduled", value: "EVENT_NAME_ON_SCHEDULED" },
          ],
        },
        {
          label: "Video",
          options: [
            { label: "Progress", value: "EVENT_NAME_ON_PROGRESS" },
            { label: "Mute", value: "EVENT_NAME_ON_MUTE" },
            { label: "Unmute", value: "EVENT_NAME_ON_UNMUTE" },
            { label: "Pause", value: "EVENT_NAME_ON_PAUSE" },
            { label: "Resume", value: "EVENT_NAME_ON_RESUME" },
            { label: "Start", value: "EVENT_NAME_ON_START" },
            { label: "First Quartile", value: "EVENT_NAME_ON_FIRST_QUARTILE" },
            { label: "Midpoint", value: "EVENT_NAME_ON_MIDPOINT" },
            { label: "Third Quartile", value: "EVENT_NAME_ON_THIRD_QUARTILE" },
            { label: "Skip", value: "EVENT_NAME_ON_SKIP" },
            { label: "Complete", value: "EVENT_NAME_ON_COMPLETE" },
          ],
        },
        {
          label: "MRAID",
          options: [
            { label: "Navigate", value: "EVENT_NAME_ON_NAVIGATE" },
            { label: "Close", value: "EVENT_NAME_ON_CLOSE" },
            {
              label: "Use Custom Close",
              value: "EVENT_NAME_ON_USE_CUSTOM_CLOSE",
            },
          ],
        },
      ]}
    />
  );
};
